// extracted by css-extract-rspack-plugin
export default {"isOnSmBreakpoint":"header-fragment__Logo_isOnSmBreakpoint__9uHgy","isOnMdBreakpoint":"header-fragment__Logo_isOnMdBreakpoint__xsZQZ","logo":"header-fragment__Logo_logo__jh7i1"};